import {
  ICallSipClientParams,
  ISipClientCreateProps,
  ISipClientHistoryProps,
  ISipClientHistoryReasonUpdateParams,
  ISipClientProps,
  ISipClientSimpleProps,
  ISipClientActionCallParams,
  ISipClientUpdateParams,
  ISipClientHistoryReasonDetailsProps,
  ISipClientHistoryFilterParams,
  ISipClientHistoryGetParams,
} from './types';
import { api } from '../DefaultService';
import { IPaginationParams } from '../types';
import { IResponsibleFilterProps } from '../ResponsibleService/types';

export const ENDPOINT_SIP_CLIENT = 'v1/sipClient';
export const ENDPOINT_SIP_CLIENT_HISTORY = 'v1/sipClientHistory';

export const createSipClientAsync = async (
  data: ISipClientCreateProps,
): Promise<ISipClientProps> => {
  return await api
    .post(ENDPOINT_SIP_CLIENT, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSipClientByIdAsync = async (
  id: number,
): Promise<ISipClientProps> => {
  return await api
    .get(`${ENDPOINT_SIP_CLIENT}/${id}`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSipClientByLicenseAsync = async (): Promise<
  ISipClientSimpleProps[]
> => {
  return await api
    .get(`${ENDPOINT_SIP_CLIENT}/getAllByLicense`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSipClientHistoryByLicenseAsync = async (
  params: ISipClientHistoryGetParams,
): Promise<ISipClientHistoryProps[]> => {
  return await api
    .get(`${ENDPOINT_SIP_CLIENT_HISTORY}/getAllByLicense`, {
      params,
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSipClientHistoryByLicenseCountAsync = async (
  filter?: ISipClientHistoryFilterParams,
): Promise<number> => {
  return await api
    .get(`${ENDPOINT_SIP_CLIENT_HISTORY}/getAllByLicense/count`, {
      params: filter,
    })
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getAllSipClientToRegisterByLicenseAsync = async (): Promise<
  ISipClientSimpleProps[]
> => {
  return await api
    .get(`${ENDPOINT_SIP_CLIENT}/getAllByLicense/toRegister`)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getSipClientHistoryReasonAsync = async (
  id: number,
): Promise<ISipClientHistoryReasonDetailsProps> => {
  return await api
    .get<ISipClientHistoryReasonDetailsProps>(
      `${ENDPOINT_SIP_CLIENT_HISTORY}/${id}/reason`,
    )
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSipClientReasonHistoryAsync = async ({
  id,
  data,
}: ISipClientHistoryReasonUpdateParams): Promise<void> => {
  return await api
    .put(`${ENDPOINT_SIP_CLIENT_HISTORY}/${id}/reason`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const updateSipClientAsync = async ({
  id,
  data,
}: ISipClientUpdateParams): Promise<ISipClientProps> => {
  return await api
    .put(`${ENDPOINT_SIP_CLIENT}/${id}`, data)
    .then((response) => response.data)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const getLastEndedCallByLoggedUser =
  async (): Promise<ISipClientHistoryProps> => {
    return await api
      .get(`${ENDPOINT_SIP_CLIENT_HISTORY}/lastEndedCallByLoggedUser`)
      .then((response) => response.data)
      .catch((error) => {
        throw new Error(
          error?.response?.data?.message || 'Erro interno do servidor!',
        );
      });
  };

export const deleteSipClientAsync = async (id: number): Promise<void> => {
  await api.delete(`${ENDPOINT_SIP_CLIENT}/${id}`).catch((error) => {
    throw new Error(
      error?.response?.data?.message || 'Erro interno do servidor!',
    );
  });
};

export const refuseSipClientAsync = async ({
  id,
  callId,
}: ISipClientActionCallParams): Promise<void> => {
  await api
    .post(`${ENDPOINT_SIP_CLIENT}/${id}/refuse/${callId}`)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const hangupSipClientAsync = async ({
  id,
  callId,
}: ISipClientActionCallParams): Promise<void> => {
  await api
    .post(`${ENDPOINT_SIP_CLIENT}/${id}/hangup/${callId}`)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const toMeetSipClientAsync = async ({
  id,
  callId,
}: ISipClientActionCallParams): Promise<void> => {
  await api
    .post(`${ENDPOINT_SIP_CLIENT}/${id}/toMeet/${callId}`)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};

export const callSipClientAsync = async ({
  id,
  phoneNumber,
}: ICallSipClientParams): Promise<void> => {
  await api
    .post(`${ENDPOINT_SIP_CLIENT}/${id}/call/${phoneNumber}`)
    .catch((error) => {
      throw new Error(
        error?.response?.data?.message || 'Erro interno do servidor!',
      );
    });
};
